import styled from 'styled-components';
export const Hideable = styled.div `
    user-select: none;
    display: flex;
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: opacity ease-in-out 400ms;
    box-sizing: border-box;

    opacity: ${(props) => (props.displayed ? 1 : 0)};
    // Probably a bug in Firefox on Mac and Windows: when the opacity of
    // this element is set to 0, mousemove events won't fire. Reproducible
    // on Firefox 113.0.2.
    @-moz-document url-prefix() {
        opacity: ${(props) => (props.displayed ? 1 : 0.00001)};
    }

    & * {
        visibility: ${(props) => (props.displayed ? 'initial' : 'hidden !important')};
        pointer-events: ${(props) => (props.displayed ? 'initial' : 'none !important')};
        touch-action: ${(props) => (props.displayed ? 'initial' : 'none !important')};
    }
`;
Hideable.displayName = 'Hideable';
export const PointerEventsHandler = styled.div `
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    pointer-events: auto;
    display: ${(props) => (!props.canParentDisplay || props.parentDisplayed ? 'none' : 'block')};
`;
PointerEventsHandler.displayName = 'PointerEventsHandler';
//# sourceMappingURL=index.js.map